import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-no-user-profile-physical-credentials',
  templateUrl: './no-user-profile-physical-credentials.component.html',
  styleUrls: ['./no-user-profile-physical-credentials.component.scss'],
})
export class NoUserProfilePhysicalCredentialsComponent {
  readonly LANG_CONST = LANG_CONST;
  @Input() userName: string = '';

  constructor() {}
}
